export default "/icons/js.svg";